import React, { useEffect, useState } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { Box, IconButton, Menu, MenuItem, TableCell, TableRow } from "@mui/material";
import TableDesign, { TableHeading } from "../../../../components/common/table/TableDesign";
import { useDispatch } from "react-redux";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { Lens } from "@mui/icons-material";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { useSelector } from "react-redux";
import { getAllSkillAction, setAddSkillAction, setDeleteSkillAction } from "../../../../store/reducers/assignWorkerSlice";
import ManageSkill from "./ManageSkill";
import AlertDeleteModel from "./AlertDeleteModel";

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}

const SkillsList = () => {
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Name", align: "left" },
    { label: "Description", align: "left" },
    { label: "Action", align: "center" },
  ];
  const dispatch = useDispatch();
  const { skills,addSkillResponse,deleteSkillResponse } = useSelector((state: any) => state.assignWorker);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const openDown = Boolean(anchorEl);
  const [open, setOpen] = useState(false);
  const [filterOption, setFilterOption] = useState<FilterOption>({
     page: 1,
     limit: 10,
     orderBy: "created_at",
     orderIn: "DESC",
   });

   useEffect(()=>{
    dispatch(getAllSkillAction())
   },[dispatch])

   useEffect(()=>{
    if(addSkillResponse || deleteSkillResponse){
      dispatch(getAllSkillAction())
      setOpen(false);
      setDeleteModelShow(false);
      setSelectedRow(null);
      dispatch(setAddSkillAction(false));
      dispatch(setDeleteSkillAction(false));
       dispatch(setNotificationAction({ message: [], severity: "info" }));
    }
   },[addSkillResponse,deleteSkillResponse])

   const handleOpen = () => {
    setOpen(true);
  };

    const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setSelectedRow(null);
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    setAnchorEl(null);
  };

  const handleEditOpen = () => {
    setAnchorEl(null);
    setOpen(true);
  };
  const handleDeleteOpen = () => {
    setAnchorEl(null);
    setDeleteModelShow(true);
  };

  return (
    <>
    {deleteModelShow &&
    <AlertDeleteModel
      alertModalShow={deleteModelShow}
      setAlertModelShow={setDeleteModelShow}
      onHide={handleClose}
      selectUser={selectedRow}
      setIsClickReset={() => {}}
    />
    }
    {open && (
      <ManageSkill
        open={open}
        onHide={handleClose}
        title={selectedRow ? "Edit Skill" : "Add Skill"}
        selectedData={selectedRow}
        isSmallScreen={false}
        action={selectedRow ? "edit" : "add"}
      />
    )}
      <PageTitle
        title="Staff Skill List"
        button="Add Skill"
        onClick={handleOpen}
      />
      <Box
        sx={{
          bgcolor: "#fff",
          height: { xs: "auto", sm: "60vh" },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
         <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={skills.length > 0 ? null : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {skills.length > 0 ? (
            skills?.map((val: any, idx: number) => (
              <TableRow
                key={val?.id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell align="left">{idx + 1}</TableCell>
                <TableCell>{val?.title}</TableCell>
                <TableCell>{val?.description}</TableCell>
                <TableCell align="center" sx={{ padding: "0px" }}>
                 {(val?.is_editable || val?.is_deletable) && <IconButton
                    sx={{ padding: "0px" }}
                    size="small"
                    id="basic-button"
                    aria-controls={openDown ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openDown ? "true" : undefined}
                    onClick={(e) => {
                      handleClick(e);
                      setSelectedRow(val);
                    }}
                  >
                    <MoreIcon />
                  </IconButton>}
                  <Menu
                    sx={{
                      boxShadow: "none",
                      border: "2px solid #eeecef",
                      "& .MuiPaper-root": {
                        boxShadow: "none", // Removes shadow on the paper element of the menu
                        border: "2px solid #eeecef",
                      },
                      top: "0px",
                    }}
                    // className={classes.menuBox}
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openDown}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                   {selectedRow?.is_editable && <MenuItem onClick={() => handleEditOpen()}>
                      <Lens
                        style={{
                          height: "4px",
                          width: "4px",
                          marginRight: "4px",
                        }}
                      />
                      Edit
                    </MenuItem>}

                    {selectedRow?.is_deletable && <MenuItem onClick={() => handleDeleteOpen()}>
                      <Lens
                        style={{
                          height: "4px",
                          width: "4px",
                          marginRight: "4px",
                        }}
                      />
                      Delete
                    </MenuItem>}
                  </Menu>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7}>
                <Box
                  sx={{
                    height: "60vh",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      fontSize: "1rem",
                      color: "#4A4A4A",
                      top: "100px",
                    }}
                  >
                    {"No Skills Found."}
                  </span>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};

export default SkillsList;
